import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import { withCreateStudent } from "src/modules/student/operations";
import { compose } from "src/helpers";

import CreateView from "./component";

const Create = (props) => {
    const { createStudent } = props;
    const router = useRouter();

    const onFinish = async (values: any) => {
        await createStudent(values);
        router.push("/student");
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return <CreateView onFinish={onFinish} onFinishFailed={onFinishFailed} />;
};

export default compose(withCreateStudent)(Create);
